import moment from "moment";
// helpers
import ApiHelper from "../../utils/apiHelper";
// actions
import { globalActionCreators } from "./globalModule";
// helpers
import { getFormattedHotelGroups, hotelPanelRootUrl, pagesUrl } from "../../utils/panel-helpers/helpers";

export const homeActionTypes = {
  SET_DATE_RANGE_SELECTION: "SET_DATE_RANGE_SELECTION",
  SET_HOTEL_DATA: "SET_HOTEL_DATA",
  UPDATE_HOTEL_DATA: "UPDATE_HOTEL_DATA",
  UPDATE_ACCOUNT_SETTINGS_DATA: "UPDATE_ACCOUNT_SETTINGS_DATA"
};

export const initialState = {
  dateRangeSelection: {
    startDate: moment().subtract(6, "days"),
    endDate: moment()
  },
  noData: false,
  hotelData: {
    hotelName: "",
    hotelUser: "",
    hotelUserId: "",
    hotelCurrency: "",
    hotelGroup: [],
    hotelEventCategories: []
  },
  isHotelGroupExists: null,
  accountSettingsData: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case homeActionTypes.SET_DATE_RANGE_SELECTION:
      return {
        ...state,
        dateRangeSelection: action.dateRangeSelection
      };
    case homeActionTypes.SET_HOTEL_DATA:
      return {
        ...state,
        hotelData: action.hotelData,
        isHotelGroupExists: action?.hotelData?.hotelGroup?.length > 0,
        account_settings: action?.hotelData?.account_settings
      };
    case homeActionTypes.UPDATE_HOTEL_DATA:
      return {
        ...state,
        hotelData: action.hotelData
      };
    case homeActionTypes.UPDATE_ACCOUNT_SETTINGS_DATA:
      return {
        ...state,
        accountSettingsData: action.accountSettingsData
      };
    default:
      return state;
  }
};

export const homeActionCreators = {
  setDateRangeSelectionAction: dateRangeSelection => {
    return {
      type: homeActionTypes.SET_DATE_RANGE_SELECTION,
      dateRangeSelection
    };
  },
  // This will be called after user call terms & conditions EP for Hotel Offers:
  updateHotelDataAction: hotelData => {
    return {
      type: homeActionTypes.UPDATE_HOTEL_DATA,
      hotelData
    };
  },
  loadHotelInfoAction: () => async (dispatch, getState) => {
    const isSingleHotelView =
      window.location.pathname !== `/${hotelPanelRootUrl}/` &&
      window.location.pathname !== `/${hotelPanelRootUrl}/${pagesUrl.bookings}`;

    // turn on global loader, if page IS NOT Dashboard or Bookings
    if (isSingleHotelView) {
      dispatch(globalActionCreators.toggleGlobalLoaderAction(true));
    }

    try {
      const res = await ApiHelper.get(`/v1/hotel-info`);

      const infoResponse = res.data;
      const hotelGroup =
        infoResponse?.hotel_group && infoResponse?.hotel_group?.length > 0
          ? getFormattedHotelGroups(infoResponse?.hotel_group, infoResponse?.hotel)
          : [];

      if (hotelGroup?.length > 0) {
        // If Hotel Group exists && if page IS NOT Bookings or Dashboard --> preselect Hotel (for case when user coming directly to the non-single hotel view page)
        if (isSingleHotelView) {
          // First is "All hotel", so we are pre-selecting next one
          dispatch(globalActionCreators.setSelectedHotelsAction([hotelGroup[1]]));
        } else {
          // pre-selecting "All Hotels"
          dispatch(globalActionCreators.setSelectedHotelsAction([hotelGroup[0]]));
        }
      }

      dispatch({
        type: homeActionTypes.SET_HOTEL_DATA,
        hotelData: {
          hotelUser: infoResponse.full_name,
          hotelUserId: infoResponse.id,
          hotelId: infoResponse.hotel.id,
          hotelName: infoResponse.hotel.name,
          hotelCurrency: infoResponse.hotel.destination.currency,
          hotelVatTaxRate: infoResponse.hotel.destination.tax_rate,
          defaultHotelSaasModel: infoResponse?.hotel?.saas_model,
          premiumFlag: infoResponse.hotel.premium_settings[4],
          hotel_offer_terms_conditions: infoResponse.hotel.hotel_offer_terms_conditions,
          hotelGroup: hotelGroup,
          hotelEventCategories: infoResponse?.hotel.destination?.hotel_offer_categories,
          account_settings: infoResponse?.hotel?.account_settings
        }
      });
    } catch (error) {
      dispatch(globalActionCreators.handleErrorAction());
    } finally {
      // turn off global loader, if page IS NOT Dashboard or Bookings
      if (isSingleHotelView) {
        dispatch(globalActionCreators.toggleGlobalLoaderAction(false));
      }
    }
  },
  setAccountSettingsDataAction: data => {
    return {
      type: homeActionTypes.UPDATE_ACCOUNT_SETTINGS_DATA,
      accountSettingsData: data
    };
  }
};
